import React from 'react';
import { InfoTip, MetricKey } from '@/components/shared';

export type StatCellAccent = 'violet' | 'emerald' | 'pink';

const ACCENT_CLASSES: Record<StatCellAccent, string> = {
  violet: 'text-violet-200',
  emerald: 'text-emerald-200',
  pink: 'text-pink-200',
};

export interface StatCellProps {
  label: string;
  value: string | number;
  accent: StatCellAccent;
  info?: MetricKey;
}

export function StatCell({ label, value, accent, info }: StatCellProps): React.ReactElement {
  return (
    <div className="flex-1 min-w-[140px] bg-gray-900/60 border border-gray-800 rounded-2xl px-5 py-4">
      <div className={`text-[11px] font-semibold uppercase tracking-widest ${ACCENT_CLASSES[accent]}`}>
        {label}
        {info && <InfoTip metric={info} />}
      </div>
      <div className="font-display text-3xl font-bold text-white mt-1 leading-none">
        {value}
      </div>
    </div>
  );
}

export default StatCell;
